import { identify, makeRequest, Service } from 'utils/http';

type Data = {
  userId: string;
};

export async function deleteInvitedUserApi({ userId }: Data) {
  return makeRequest(Service.deleteInvitedUser({ userId }, await identify()));
}
